import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const CrackOutlinedSvg = () => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.9}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="11,2.5 8.5,8.5 12.5,12 9.5,16.5 11,21.5" />
    <polyline points="12.5,12 17,13.5 18.5,18.5" />
    <polyline points="8.5,8.5 4.5,9.5" />
  </svg>
);

export const CrackOutlined = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CrackOutlinedSvg} {...props} />
);
